module.exports = __webpack_public_path__ + "img/arrow-left.779cd1ca.svg";